import { Directive, HostListener, Input, Output, EventEmitter, HostBinding } from "@angular/core";
import { LxmDialog } from "../_helpers";
import { SubscriptionRestrictedDialogComponent } from "../dialogs/subscription-restricted/subscription-restricted.dialog";
import { AppState } from "../state/app.state";
import { QuotaRestrictedDialogComponent } from "../dialogs/quota-restricted/quota-restricted.dialog";

@Directive({
  selector: "[subscriptionRestricted]"
})
export class SubscriptionRestrictedDirective {

  @Output() public onUnrestrictedClick = new EventEmitter<void>();

  @Input() public subscriptionRestricted: boolean;

  constructor(
    private _dialog: LxmDialog,
    private _appState: AppState
  ) { }

  @HostBinding('class.subscription-restricted') public get isRestricted() {
    if (typeof this.subscriptionRestricted === 'boolean') {
      return this.subscriptionRestricted;
    }
    return !this._appState.hasSubscription;
  }

  @HostListener("click") public onHostClick() {
    if (this.isRestricted) {
      this._dialog.closeAll();
      this._dialog.open(SubscriptionRestrictedDialogComponent, {
        width: "auto"
      });
    } else {
      this.onUnrestrictedClick.emit();
    }
  }
}

@Directive({
  selector: "[quotaRestricted]"
})
export class QuotaRestrictedDirective {

  @Output() public onUnrestrictedClick = new EventEmitter<void>();

  @Input() public quotaRestricted: boolean;

  constructor(
    private _dialog: LxmDialog,
    private _appState: AppState
  ) { }

  @HostBinding('class.subscription-restricted') public get isRestricted() {
    if (typeof this.quotaRestricted === 'boolean') {
      return this.quotaRestricted;
    }
    return !this._appState.hasSubscription;
  }

  @HostListener("click") public onHostClick() {
    if (this.isRestricted) {
      this._dialog.closeAll();
      this._dialog.open(QuotaRestrictedDialogComponent, {
        width: "auto"
      });
    } else {
      this.onUnrestrictedClick.emit();
    }
  }
}
